import ConfirmBlock from "./ConfirmBlock";
import ChangeStatus from "./ChangeStatus";

const Dialogs = {
  ConfirmBlock,
  ChangeStatus,
}

export default Dialogs;